function kryptonApp(): any {
    return document.getElementById("krypton-app");
}
import { PageElement } from "../elements/page-element";
import { AnimationHelper } from "./animation_helper";
import { closeOverlay, hideLoadingCurtain, showLoadingCurtain, getContentHtml, resetPageScroll } from "./global_function";
import { KryptonConstants } from "./krypton_constants";
import { scripter } from "./scripter";
import { UrlResolver } from './urlResolver'

export type FORM_TARGET = "default" | "new" | "opener" | "module";

class FormDetails {
    formIdentifier: HTMLFormElement;// This can be a form object itself or just the name of the form
    toNewLayer: boolean;
    page: PageElement;
    multiplePages: boolean;
    responseText: any;
    form: any
    hasError: boolean = false;
    pageToStayOnError: any;
    callBack: any;
    openAsModule: boolean;
    isFileUpload: boolean;
    loadingCurtainDetails: any;
    doNotSetContentsToPageIfError: boolean;
    constructor(formIdentifier: HTMLFormElement, toNewLayer: boolean = false, page: PageElement = kryptonApp().pageManager.topPage, multiplePages: boolean = false, loadingCurtainDetails?: any) {
        this.formIdentifier = formIdentifier;
        this.toNewLayer = toNewLayer;
        this.page = page;
        this.multiplePages = multiplePages;
        this.loadingCurtainDetails = loadingCurtainDetails;
    }
}

export function serializeObject(form: HTMLFormElement) {

    if (!form || form.nodeName !== "FORM")
        return;

    let q: any[] = [];

    for (let i = form.elements.length - 1; i >= 0; i = i - 1) {

        let element: any = form.elements[i];

        if (element.name === "")
            continue;

        switch (element.nodeName) {

            case 'INPUT':
                switch (element.type) {
                    case 'text':
                    case 'hidden':
                    case 'password':
                    case 'button':
                    case 'reset':
                    case 'submit':
                        q.push(element.name + "=" + encodeURIComponent(element.value));
                        break;
                    case 'checkbox':
                    case 'radio':
                        if (element.checked) {
                            q.push(element.name + "=" + encodeURIComponent(element.value));
                        }
                        break;
                    case 'file':
                        break;
                }
                break;

            case 'TEXTAREA':
                q.push(element.name + "=" + encodeURIComponent(element.value));
                break;

            case 'SELECT':
                switch (element.type) {
                    case 'select-one':
                        q.push(element.name + "=" + encodeURIComponent(element.value));
                        break;
                    case 'select-multiple':
                        for (let j = element.options.length - 1; j >= 0; j = j - 1) {
                            if (element.options[j].selected) {
                                q.push(element.name + "=" + encodeURIComponent(element.options[j].value));
                            }
                        }
                        break;
                }
                break;

            case 'BUTTON':
                switch (element.type) {
                    case 'reset':
                    case 'submit':
                    case 'button':
                        q.push(element.name + "=" + encodeURIComponent(element.value));
                        break;
                }
                break;
        }
    }
    return q.join("&");
}

function prepareForm(args: any) {
    let namespace = args[0];
    if (!!(namespace && typeof namespace === "object" && namespace.kryptonNamespace)) {
        args.shift();
    }
    let form = getForm(args[0]);
    if (args.length > 1 && args[1]) {
        setAction(form, args[1]);
    }
    return form;
}

function setAction(form, action) {
    // Application sends different arguments.  Some times the form.action is already set with query parameters but the action being passed does not have it
    // so make sure we replace the action only if the action is actually different from what we need
    let formAction = form?.action || "";
    let pos = formAction.indexOf("?");
    if (pos > -1) {
        formAction = formAction.substring(0, pos);
    }
    if (typeof (action) === "string" && formAction.indexOf(action) < 0) {
        form.action = action;
    }
}

function getLoadingCurtainDetails(args) {
    let details = undefined;
    if (args && args.length) {
        for (const arg of args) {
            if (arg && arg.loadingCurtainDetails) {
                return arg;
            }
        }
    }
    return details;
}

function getDoNotSetContentsToPageIfError(args) {
    let details = undefined;
    if (args && args.length) {
        for (const arg of args) {
            if (arg && arg.doNotSetContentsToPageIfError) {
                return arg;
            }
        }
    }
    return details;
}

//This is copied from notification-utilities.js and modified.  We decided to keep this for now as there are complex scenarios and may need more R&D to work on a cleaner solution
function isNotificationError(htmlResponse, global) {
    if (htmlResponse) {
        if (typeof htmlResponse == "string") {
            //TODO Jonathan:- this is a bad marker. Something more generic should be used
            if (htmlResponse.indexOf("<!--ERROR-PAGE-->") >= 0) {
                return true;
            }
            if (global) {
                let pos = htmlResponse.indexOf("krypton-notification-script");
                if (pos >= 0) {
                    let end = htmlResponse.indexOf("</", pos);
                    let errorString = htmlResponse.substring(pos, end);
                    if (errorString.indexOf("\"error\"") > -1 || errorString.indexOf("'error'") > -1) {
                        return true;
                    }
                }
            }
        }
        if (typeof htmlResponse == "object" && htmlResponse.responseText) {
            return isNotificationError(htmlResponse.responseText, global);
        }
    }
    return false;
}

function isOnlyShowErrorRequired(formDetails: FormDetails, fragment: any) {
    return !fragment.querySelector("form") || formDetails.doNotSetContentsToPageIfError;
}

function isErrorInResponseAndHandledResponse(formDetails: FormDetails) {
    let isStopping = false;
    // The old way - check if the response html has the text createNotification
    if (isNotificationError(formDetails.responseText, true)) {
        formDetails.hasError = true;
        if (formDetails.pageToStayOnError) { // If pageToStayOnError is defined, then we should stop processing (return true)
            const fragment = getContentHtml(formDetails.responseText);
            // On error the page may contain only createNotification script 
            // Transaction Quick Query returns just the script with errors. So do not populate page with response, rather just execute the error script.
            if (isOnlyShowErrorRequired(formDetails, fragment)) {
                // If no form, it should be only createNotification(s) - execute the scripts (ideally notification scripts)
                executeScriptFromContent(fragment, formDetails);
                isStopping = true;
            } else if (!formDetails.toNewLayer) {
                // If we have the full page, then reload current page
                formDetails.pageToStayOnError.reinitializePageToContent(formDetails.responseText);
                isStopping = true;
            }
        } else if (formDetails.doNotSetContentsToPageIfError) {// No pageToStayOnError is defined, however, doNotSetContentsToPageIfError is set, so just execute the error script
            formDetails.pageToStayOnError = formDetails.page;
            executeScriptFromContent(getContentHtml(formDetails.responseText), formDetails);
            isStopping = true;
        }// else if the details are to be shown in a new page, we have to return false to proceed further and load page as a new page
    }
    return isStopping;
}

function executeScriptFromContent(fragment, formDetails) {
    for (let s of fragment.querySelectorAll("script")) {
        if (!s.hasAttribute("src")) {// No need to load the scripts with a source attribute as it should already be there.
            formDetails.pageToStayOnError.appendChild(scripter(s));
            let oldForm: any = formDetails.pageToStayOnError.querySelector("form");
            if (oldForm.busy) {
                //We have shown the error messages by now.  User should be able to submit this form again, so reset already submitted flag
                oldForm.busy = false;
            }
        }
    }
}

async function openAndShowPage(formDetails: FormDetails) {
    let currentForm = formDetails?.page?.closest("form");
    let newPage = await kryptonApp().getNewPage(formDetails.form.action, formDetails.responseText, formDetails.openAsModule ? undefined : formDetails.page);
    kryptonApp().showPage(newPage, false, formDetails.toNewLayer);
    if (formDetails.openAsModule) {
        newPage.opener = undefined;
    } else {
        let frm = newPage.querySelector("form")
        if (frm) {
            frm.openerForm = currentForm;
        }
    }
    formDetails.page = newPage;
    return newPage;
}

function doubleSubmitProtection(formDetails: FormDetails): boolean {
    if (formDetails.form?.protectDoubleSubmit) {
        clearTimeout(formDetails.form.protectDoubleSubmit);
        formDetails.form.protectDoubleSubmit = setTimeout(() => {
            formDetails.form.protectDoubleSubmit = undefined;
        }, 300);
        return true;
    }
    formDetails.form.protectDoubleSubmit = setTimeout(() => {
        formDetails.form.protectDoubleSubmit = undefined;
    }, 300);
    return false;
}

export async function submitForm(formDetails: FormDetails, resultAsScript: boolean = false, redirectToAction: boolean = false) {
    showLoadingCurtain(formDetails.loadingCurtainDetails);
    formDetails.form = getForm(formDetails.formIdentifier);
    if (doubleSubmitProtection(formDetails)) {
        // some methods await the result of this method for some additional processing.  they need to be stopped, so just set the error as true
        formDetails.hasError = true;
        console.warn("Prevented double submit");
        return;
    }
    const formData = new FormData(formDetails.form);
    if (formDetails.toNewLayer) {
        formDetails.form.target = "new";
    }
    let result: any;
    let fetchUrl = UrlResolver.RELATIVE.resolve(formDetails.form.action)
    switch (formDetails.form.method) {
        case "post":
            //-- sending body as x-www-form-url-encoded
            result = await fetch(fetchUrl, {
                method: formDetails.form.method,
                body: formDetails.isFileUpload ? formData : new URLSearchParams([...(formData as any)])
            }).then((response: Response) => response).catch(error => console.error(error));
            break;
        case "get":
            //-- sending body as x-www-form-url-encoded
            result = await fetch(fetchUrl + "&" + serializeObject(formDetails.form), {
                method: formDetails.form.method
            }).then((response: Response) => response).catch(error => console.error(error));
            break;
    }
    if (!result.ok) {
        kryptonApp().showErrorNotification(result.status);
        return;
    }
    formDetails.responseText = await result.text();
    resetPageScroll();
    if (resultAsScript) {

        executeScript(formDetails);
        hideLoadingCurtain();
    } else if (isErrorInResponseAndHandledResponse(formDetails)) {// We have the result now, check if it has error messages, decide what to do next
        // Okay, we are not processing this further, just close the loading curtain
        hideLoadingCurtain();
    } else {
        if (formDetails.callBack) {
            // If there is a callback handler (usually for slider animations), execute it before proceeding further
            // If we are stop processing we will not reach here and this will prevent any animation
            try {
                await formDetails.callBack.handler(...formDetails.callBack.args);
            } catch (e) {
                console.error(e);
            }
        }
        if (!redirectToAction) {
            await openFormResponse(formDetails);
        }
    }
}

function executeScript(formDetails: FormDetails) {
    let page: any = formDetails.page;
    let form = page.querySelector("form")
    const fragment = getContentHtml(formDetails.responseText);
    // If no form, it should be only createNotification(s) - execute the scripts (ideally notification scripts)
    for (let s of fragment.querySelectorAll("script")) {
        if (!s.hasAttribute("src")) {// No need to load the scripts with a source attribute as it should already be there.
            try {
                page.appendChild(scripter(s));
            } catch (er) {
                console.error(er);
            }
        }
    }
    if (form) {
        form.busy = false;
    }
}

async function openFormResponse(formDetails: FormDetails) {

    if (!(KryptonConstants.allowMultiplePages || formDetails.multiplePages || formDetails.toNewLayer)) {
        // not a new layer
        if (formDetails.openAsModule) { // Open as new module, all existing page-elements are gone by now
            await openAndShowPage(formDetails);
        } else { // Reuse the same page with new contents
            formDetails.page.reinitializePageToContent(formDetails.responseText);
        }
    } else {
        switch (formDetails.form?.target) {
            case "new": //-- new
                await openAndShowPage(formDetails);
                break;
            case "opener": //-- opener
                let pageToLoad = formDetails.page.opener || formDetails.page;
                formDetails.page = pageToLoad;
                formDetails.page && formDetails.page.reinitializePageToContent && formDetails.page.reinitializePageToContent(formDetails.responseText);
                break;
            default: //-- self
                // Just setting innerHTML won't work, the styles and scripts will need to be reapplied just like the first time the page is loaded
                formDetails.page.reinitializePageToContent(formDetails.responseText);
                break;
        }
    }
    formDetails.page.open = true;
    formDetails.page.isPageCreatedFromAFormSubmit = !formDetails.openAsModule;
}

export function getForm(form: any) {
    let formObject = form;
    if (typeof (form) === "string") {
        formObject = kryptonApp().pageManager.topPage.querySelector('[name="' + form + '"]') || document.forms[form];
    }
    return formObject;
}

// The first argument can be a form or the name of form
export function submitFormAndClose(formIdentifier: HTMLFormElement, action: String, forceClose: boolean = false, details?: any) {
    showLoadingCurtain(details);
    var page = kryptonApp().pageManager.topPage;
    let form = prepareForm([formIdentifier, action])
    if (form) {
        form.target = "opener";
    }
    let formDetails: FormDetails = new FormDetails(form, false, page, true, details)
    formDetails.doNotSetContentsToPageIfError = getDoNotSetContentsToPageIfError([details]);
    if (!forceClose) {
        formDetails.pageToStayOnError = page;  // We need to stop processing if there is an error
    }
    // If we have multiple overlays (page-element) say 4, and we want to reload contents to the 2nd page-element and close 3rd and 4th,
    // we pass the second page-element in details.specificPageToLoadResults.
    let specificPageToLoad = details?.specificPageToLoadResults;
    if (specificPageToLoad) {
        form.target = "_self"; // so that openFormResponse will not go to page.opener again.  If form.target = "opener", then it load only to formDetails.page.opener
        formDetails.page = specificPageToLoad;
    }
    (async () => {
        await submitForm(formDetails);// The page to show results is the parent page
        if (forceClose || !formDetails.hasError) {// Do not close if the page has an error, show the message and just stay there!
            if (specificPageToLoad) {
                //close all overlays till we reach the specified page to load results
                while (page && page != specificPageToLoad) {
                    let newPage = page.opener;
                    closeOverlay(page, true);
                    page = newPage;
                }
            } else {
                closeOverlay(page, true);
            }
        }
    })();
    return false; // To prevent double processing for button click
}

export function submitFormAndOpenModule(...args) {
    let form = prepareForm(args);
    form.target = "new";
    let formDetails = new FormDetails(form, false, undefined, false, getLoadingCurtainDetails(args));
    formDetails.openAsModule = true;
    formDetails.pageToStayOnError = kryptonApp().pageManager.topPage;
    formDetails.callBack = {// callback handler
        handler: async () => {
            kryptonApp().pageManager.clear();//remove all pages and then load the new page as a fresh one
        }, args: []
    }
    submitForm(formDetails);
}

export function submitFormForWindow(...args) {
    // This could be coming from 
    // 1. The ledger page - there is only one page in the app now, and it should be reloaded
    // 2. An overlay - at least two pages and this overlay's page should be reloaded
    // 3. A search window in the slider - now, this page element is not inside page-manager, rather it is inside slider-element and this page should be reloaded
    //         most likely it is result of search performed
    let form = prepareForm(args);
    let formDetails = new FormDetails(form, false, form.closest("page-element"), false, getLoadingCurtainDetails(args));
    formDetails.doNotSetContentsToPageIfError = getDoNotSetContentsToPageIfError(args);
    submitForm(formDetails);
    return false; // To prevent double processing for button click
}

export function submitFormForResultAsScript(...args) {
    let form = prepareForm(args);
    submitForm(new FormDetails(form, false, form.closest("page-element"), false, getLoadingCurtainDetails(args)), true);
    return false; // To prevent double processing for button click
}

export function openForm(...args) {
    let form = prepareForm(args);
    let formDetails = new FormDetails(form, true, form.closest("page-element"));
    formDetails.pageToStayOnError = kryptonApp().pageManager.topPage;
    submitForm(formDetails);
}

export function createAndSubmitIntoOverlayIfNoError(formIdentifier: any) {
    let form = prepareForm([formIdentifier]);
    let formDetails = new FormDetails(form, true, form.closest('page-element'));
    formDetails.pageToStayOnError = kryptonApp().pageManager.topPage;
    formDetails.doNotSetContentsToPageIfError = true;
    submitForm(formDetails);
}

export function createAndSubmitIntoOverlay(...args) {
    openForm(args[0]);// Second argument is not action url, it is just a route name
}

export function createAndSubmitIntoSlider(...args) {
    let form = prepareForm([args[0]]);// Second argument is not action url, it is just a route name
    submitForm(new FormDetails(form, true, kryptonApp().pageManager.topPage, true));
}

export function submitFileUpload(...args) {
    const loadingCurtainDetails = getLoadingCurtainDetails(args);
    const doNotSetContentsToPageIfError = getDoNotSetContentsToPageIfError(args);
    showLoadingCurtain(loadingCurtainDetails);
    (async () => {
        let form = prepareForm(args);
        let page = form.closest("page-element");
        let formDetails = new FormDetails(form, false, page, false, loadingCurtainDetails);
        formDetails.isFileUpload = true;
        formDetails.doNotSetContentsToPageIfError = doNotSetContentsToPageIfError;
        formDetails.pageToStayOnError = page;  // We need to stop processing if there is an error
        submitForm(formDetails);
    })()
}

export function submitFileUploadAndClose(...args) {
    const loadingCurtainDetails = getLoadingCurtainDetails(args);
    showLoadingCurtain();
    (async () => {
        let form = prepareForm(args);
        if (form) {
            form.target = "opener";
        }
        let page = form.closest("page-element");
        let formDetails = new FormDetails(form, false, page && (page.opener || page), false, loadingCurtainDetails);
        formDetails.isFileUpload = true;
        formDetails.pageToStayOnError = page;  // We need to stop processing if there is an error
        formDetails.doNotSetContentsToPageIfError = getDoNotSetContentsToPageIfError(args);
        await submitForm(formDetails);
        if (!formDetails.hasError) {// Do not close if the page has an error, show the message and just stay there!
            closeOverlay(page, true);
        }
    })()
}

export function submitSmfForm(formIdentifier: any, action: any, nextOrBack: any = undefined) {
    showLoadingCurtain();
    let form = prepareForm([formIdentifier, action]);
    let formDetails: FormDetails = new FormDetails(form, false, form.closest("page-element"));
    formDetails.pageToStayOnError = kryptonApp().pageManager.topPage;
    (async () => {
        formDetails.callBack = {// callback handler for animation. This will not be invoked if there is an error
            handler: async (form, nextOrBack) => {
                if (nextOrBack) {// nextOrBack can be undefined for success page or last submit page - no sliding needed for that
                    await AnimationHelper.ANIMATE_HORIZONTAL.animateSlideOut(form, nextOrBack === "back");
                }
            }, args: [form, nextOrBack]
        }

        await submitForm(formDetails);
        if (!formDetails.hasError && nextOrBack) {
            // If there is no error, complete the animation for sliding in the new page.   nextOrBack can be undefined for success page or 
            // last submit page - no sliding needed for that
            AnimationHelper.ANIMATE_HORIZONTAL.animateSlideIn(kryptonApp().pageManager.topPage.querySelector("form"), nextOrBack === "back");
        }
    })();
    return false; // To prevent double processing for button click
}

function submitFormToDownloadFile(form) {
    form && form.forceSubmit && form.forceSubmit();
    hideLoadingCurtain();
}

export function submitEmptyForm(page, action) {
    let form = document.createElement("form");
    form.action = action;
    let formDetails = new FormDetails(form, false, page, false, undefined);
    submitForm(formDetails);
}

export function submitFormAndRedirect(formIdentifier: HTMLFormElement, redirectAction: any, details?: any) {
    showLoadingCurtain(details);
    var page = kryptonApp().pageManager.topPage;
    let form = prepareForm([formIdentifier])
    if (form) {
        form.target = "opener";
    }
    let formDetails: FormDetails = new FormDetails(form, false, page.opener || page, true, details)
    formDetails.doNotSetContentsToPageIfError = true;
    formDetails.pageToStayOnError = page;  // We need to stop processing if there is an error
    (async () => {
        await submitForm(formDetails, false, true);// The page to show results is the parent page
        if (!formDetails.hasError) {// Do not redirect if the page has an error, show the message and just stay there!
            window["location"] = redirectAction;
        }
    })();
    return false; // To prevent double processing for button click
}

window["submitForm"] = submitFormForWindow;//Submit to same form
window["submitFormForResultAsScript"] = submitFormForResultAsScript;//Submit and the result is just a script to get executed!
window["submitPopupForm"] = submitFormForWindow;
window["submitSmfForm"] = submitSmfForm;
window["submitFormAndClose"] = submitFormAndClose;
window["submitFilter"] = submitFormAndClose;
window["createAndSubmitIntoSlider"] = createAndSubmitIntoSlider;
window["submitFormAndOpenModule"] = submitFormAndOpenModule
window["openForm"] = openForm
window["createAndSubmitIntoOverlay"] = createAndSubmitIntoOverlay
window["submitFileUpload"] = submitFileUpload;
window["submitFileUploadAndClose"] = submitFileUploadAndClose;
window["isNotification"] = isNotificationError;
window["submitFormToDownloadFile"] = submitFormToDownloadFile;
window["submitEmptyForm"] = submitEmptyForm;
window["submitFormAndRedirect"] = submitFormAndRedirect;
window["createAndSubmitIntoOverlayIfNoError"] = createAndSubmitIntoOverlayIfNoError;
